module.exports = __webpack_public_path__ + "img/12.361d46ef.png";